
export const formatTime = (timeString) => {
  if (!timeString) return '';
  const [hourStr, minute, second] = timeString.split(':');
  let hour = parseInt(hourStr, 10);
  const isPM = hour >= 12;
  const suffix = isPM ? 'PM' : 'AM';

  if (hour === 0) hour = 12;
  else if (hour > 12) hour -= 12;

  return `${String(hour).padStart(2, '0')}:${minute}:${second} ${suffix}`;
};
